export default "__VITE_PUBLIC_ASSET__23a073d0__"